import { initElmApp } from 'elm/utilities'
import * as SegmentMapContainer from 'elm/src/SegmentMapContainer.elm'
import { SegmentMap } from 'visualizations/segment-map'
import { ImageStore } from 'visualizations/image-store'

export function init (): null {
  const app = initElmApp(SegmentMapContainer)
  const targetContainer = document.getElementById('segment_map') as HTMLElement

  app.ports.render.subscribe((data: any) => {
    const blobIds = data.nodes.map(n => n.blobId)
    const imageStore = new ImageStore(data.settings.depotId, blobIds)
    const segmentMap = new SegmentMap(targetContainer, data.settings, data.nodes, imageStore)

    segmentMap.on('click', nodeId => app.ports.nodeClicked.send(nodeId))
    segmentMap.on('hover', nodeId => app.ports.nodeHovered.send(nodeId))
    segmentMap.on('unhover', nodeId => app.ports.nodeUnhovered.send(nodeId))
    segmentMap.on('unclick', () => {
      app.ports.unclicked.send('')
      layoverController().clear()
    })

    app.ports.highlightColor.subscribe((highlightedColor: any) => {
      segmentMap.updateGroupCounts(highlightedColor)
      segmentMap.highlightByColorId(highlightedColor.id)
      layoverController().clear()
    })

    imageStore.connect()
      .then(() => {
        segmentMap.loadImages()
      })
      .catch(err => {
        console.error('Error connecting to image store', err)
      })
  })

  app.ports.openCard.subscribe((nodeId: string) => {
    layoverController().load(nodeId, 'card')
  })
}

const layoverController = (): object => {
  return globalThis._APPLICATION_.getControllerForElementAndIdentifier(document.getElementById('layover'), 'layover')
}
